import React, { useEffect, useState, useMemo } from "react";
import "./bootstrap.css";
import MaterialDetail from './MaterialDetail';
import MaterialDetailModal from './MaterialDetailModal';
import { fetchAndNormalize, normalizeRow } from './api/materials';

export default function MaterialList() {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState("");

  const fetchMaterials = async () => {
    setLoading(true);
    setError(null);
    try {
      const list = await fetchAndNormalize();
      setMaterials(list);
    } catch (err) {
      setError(err.message || "Błąd podczas pobierania danych");
      setMaterials([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMaterials();
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return materials;
    return materials.filter((m) => {
      if (!m) return false;
      return (
        String(m.id).includes(q) ||
        (m.name && m.name.toLowerCase().includes(q)) ||
        (m.code && m.code.toLowerCase().includes(q)) ||
        (m.temp_max && m.temp_max.toString().includes(q)) ||
        (m.temp_min && m.temp_min.toString().includes(q)) ||
        (m.enclosedLabel && m.enclosedLabel.toString().includes(q))
      );
    });
  }, [materials, query]);

  function inferEnclosed(m) {
    if (!m) return 'Nieznany';
    if (m.enclosedLabel) return String(m.enclosedLabel);
    const meta = (m._raw && m._raw.metadata) ? (typeof m._raw.metadata === 'string' ? (() => { try { return JSON.parse(m._raw.metadata); } catch { return {}; } })() : m._raw.metadata) : {};
    if (meta && meta.enclosedLabel) return String(meta.enclosedLabel);
  }

  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const closeModal = () => setSelectedMaterial(null);

  return (
    <div className="container py-4 material-list">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="h4 mb-0">Materiały do druku 3D</h2>
        <div>
          <button onClick={fetchMaterials} disabled={loading} className="btn btn-primary btn-sm">
            Odśwież
          </button>
        </div>
      </div>

      <div className="mb-3">
        <input
          placeholder="Szukaj (nazwa, kod)..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="form-control"
        />
      </div>

      {loading && <div className="alert alert-info">Ładowanie materiałów…</div>}
      {error && <div className="alert alert-danger">Wystąpił problem techniczny z bazą danych.</div>}

      {!loading && !error && (
        <div className="table-responsive">
          <table className="table table-sm table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>Nazwa</th>
                <th>Kod</th>
                <th>Wymagana komora</th>
                <th className="text-center">Temp dyszy (°C)</th>
                <th className="text-center">Akcje</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-muted py-3">
                    Brak materiałów do wyświetlenia.
                  </td>
                </tr>
              )}
              {filtered.map((m) => (
                <tr key={m.id}>
                  <td>{m.name}</td>
                  <td>{m.code}</td>
                  <td>{m.enclosedLabel}</td>
                  <td className="text-center">{m.temp_min ?? m.temp_max ? `${m.temp_min ?? '-'} — ${m.temp_max ?? '-'}` : '-'}</td>
                  <td className="text-center">
                    <button className="btn btn-outline-primary btn-sm" onClick={() => setSelectedMaterial(m)}>
                      Szczegóły
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

  {selectedMaterial && <MaterialDetailModal material={selectedMaterial} onClose={closeModal} />}

    </div>
  );
}

export { MaterialDetailModal };
